import { useState, useEffect } from "react";
import InputData from "./InputData";
import InputIconSearchPanelMultiSelection from "./InputIconSearchPanelMultiSelection";
import Dropdown from "./Dropdown";
import Tag from "./Tag";
import DataTable from "react-data-table-component";
import ButtonIconH from "./ButtonIconH";
import CheckBox from "./CheckBox";
import PopupMessage from "./PopupMessage";
import ActionPopup from "./ActionPopup";
import TooltipBox from "./Tooltip";
import { CRMList } from "./CRMList";
import { CRMNewList } from "./CRMNewList";
import {
  userData,
  inputOnEnter,
  crmChannels,
  crmTypeList,
  formatValueUnit,
} from "../js/utils";
import { CRMListsColumns } from "../js/tableColumns";
import moment from "moment";
import { post } from "../js/post";

export function CRMLists() {
  const [popupQuestion, setPopupQuestion] = useState(null);
  const [actionPopup, setActionPopup] = useState(false);
  const [actionComponent, setActionComponent] = useState(null);
  const [listsList, setListsList] = useState([]);
  const [listsListFixed, setListsListFixed] = useState([]);
  const [selectedLists, setSelectedLists] = useState([]);
  const [totalLists, setTotalLists] = useState(0);
  const [searchData, setSearchData] = useState({
    nombre: "",
    fechaDesde: "",
    fechaHasta: "",
    tipo: "",
    start: 0,
  });
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [handleNewList, setHandleNewList] = useState(false);

  // console.log("LISTAS: ", listsList);
  // console.log("LISTAS FIX: ", listsListFixed);

  const columnsWithInputs = CRMListsColumns.map((col) => {
    if (col.name === "") {
      return {
        ...col,
        selector: (row) =>
          !row.soloLectura ? (
            <CheckBox
              active={selectedLists.includes(row.idLista)}
              onClick={() => handleCheckboxChange(row.idLista)}
            />
          ) : (
            <>
              <img
                src={`/images/icon-error.svg`}
                data-tooltip-id={String(row.idLista)}
                className="icon-pref"
                alt="Info"
              ></img>
              <TooltipBox
                id={String(row.idLista)}
                content={
                  <div className="opt-table-tooltip grid-5">
                    <div className="cell combined-cells-5 cell-start-content">
                      Esta lista no se puede eliminar porque tiene una campaña
                      asignada activa.
                    </div>
                  </div>
                }
              ></TooltipBox>
            </>
          ),
      };
    }

    return col;
  });

  const handleOpenActionPopup = (componentType, data) => {
    switch (componentType) {
      case "list":
        setActionComponent({
          name: "Ficha de lista",
          component: (
            <CRMList
              data={data}
              createPopupQuestion={createPopupQuestion}
              removePopupQuestion={removePopupQuestion}
              onClose={async () => {
                setSearchData((prev) => ({
                  ...prev,
                  start: 0,
                }));
                await getListsList(0);
                setActionPopup(false);
                setActionComponent(null);
              }}
              onRemovePatients={async () => {
                setSearchData((prev) => ({
                  ...prev,
                  start: 0,
                }));
                await getListsList(0);
              }}
            />
          ),
        });
        break;
      case "newList":
        setActionComponent({
          name: "Nueva lista",
          component: (
            <CRMNewList
              createPopupQuestion={createPopupQuestion}
              removePopupQuestion={removePopupQuestion}
              onClose={async () => {
                setSearchData((prev) => ({
                  ...prev,
                  start: 0,
                }));
                await getListsList(0);
                setActionPopup(false);
                setActionComponent(null);
              }}
            />
          ),
        });
        break;
      default:
        setActionComponent(null);
    }
    setActionPopup(true);
  };

  const createPopupQuestion = (
    text,
    onClickAccept,
    onClickCancel,
    textAccept,
    textCancel,
  ) => {
    setPopupQuestion({
      text,
      onClickCancel,
      onClickAccept,
      textAccept,
      textCancel,
    });
  };

  const removePopupQuestion = () => {
    setPopupQuestion(null);
  };

  function handleSelectAll() {
    setSelectedLists((prev) => {
      const newIds = listsList
        .filter((e) => !e.soloLectura && !prev.includes(e.idLista))
        .map((e) => e.idLista);

      return [...prev, ...newIds];
    });
  }

  function handleCleanAll() {
    setSelectedLists([]);
  }

  function handleCheckboxChange(idList) {
    setSelectedLists((prevSelected) =>
      prevSelected.includes(idList)
        ? prevSelected.filter((id) => id !== idList)
        : [...prevSelected, idList],
    );
  }

  async function getListsList(start) {
    const response = await post("support-extra/crm/ListarListasCRM.php", {
      token: userData.token,
      nombre: searchData.nombre,
      fechaDesde: searchData.fechaDesde,
      fechaHasta: searchData.fechaHasta,
      canal: selectedChannels,
      tipo: searchData.tipo,
      start: start,
    });
    // console.log(
      // "LISTAR LISTAS: ",
      // {
        // token: userData.token,
        // nombre: searchData.nombre,
        // fechaDesde: searchData.fechaDesde,
        // fechaHasta: searchData.fechaHasta,
        // canal: selectedChannels,
        // tipo: searchData.tipo,
        // start: start,
      // },
      // response,
    // );
    setTotalLists(response.total);
    if (start === 0) {
      setListsList(response.listas);
      setListsListFixed(response.listas);
    } else {
      setListsList(response.listas);
    }
  }

  async function deleteLists() {
    await post("support-extra/crm/EliminarListaCRM.php", {
      token: userData.token,
      idListas: selectedLists,
    });
    // console.log("ELIMINANDO LISTAS: ", {
      // token: userData.token,
      // idListas: selectedLists,
    // });
  }

  function resetFilters() {
    setSearchData({
      nombre: "",
      fechaDesde: "",
      fechaHasta: "",
      tipo: "",
      start: 0,
    });
    setSelectedChannels([]);
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getListsList(searchData.start);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchData, selectedChannels]);

  useEffect(() => {
    setListsListFixed((prev) => {
      const newLists = listsList.filter(
        (newList) =>
          !prev.some(
            (existingList) => existingList.idLista === newList.idLista,
          ),
      );

      return [...prev, ...newLists];
    });
  }, [listsList]);

  return (
    <div className="thin-rounded-border">
      {actionPopup && (
        <ActionPopup
          name={actionComponent.name}
          children={actionComponent.component}
          overflowStyle={false}
          customClass="background-crm"
          onClose={async () => {
            setActionPopup(false);
            setActionComponent(null);
          }}
        ></ActionPopup>
      )}
      {handleNewList && (
        <CRMNewList
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
          onClose={async () => {
            setHandleNewList(false);
            setSearchData((prev) => ({
              ...prev,
              start: 0,
            }));
            await getListsList(0);
          }}
        />
      )}
      {popupQuestion && (
        <PopupMessage
          text={popupQuestion.text}
          onClickCancel={popupQuestion.onClickCancel}
          onClickAccept={popupQuestion.onClickAccept}
          textAccept={popupQuestion.textAccept}
          textCancel={popupQuestion.textCancel}
        ></PopupMessage>
      )}
      <div className="opt-table-content grid-10" id="crm-list">
        <div className="cell cell-start-content">Nombre</div>
        <div className="cell">
          <InputData
            tabIndex={1}
            type="type-alphanum-ext"
            size={0}
            input={searchData.nombre}
            onChange={(e) => {
              setSearchData((prev) => ({
                ...prev,
                nombre: e,
                start: 0,
              }));
            }}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">Fecha desde</div>
        <div className="cell">
          <input
            type="date"
            max="9999-12-31"
            tabIndex={2}
            className="input-field input-cell"
            value={searchData.fechaDesde}
            onChange={(e) => {
              const value = e.target.value;
              setSearchData((prev) => ({
                ...prev,
                fechaDesde: value ? moment(value).format("YYYY-MM-DD") : "",
                start: 0,
              }));
            }}
            onKeyUp={(e) => inputOnEnter(e)}
          ></input>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">Tipo</div>
        <div className="cell">
          <Dropdown
            tabIndex={4}
            optionList={[{ id: "", text: "" }, ...crmTypeList]}
            size={0}
            op={searchData.tipo}
            onChange={(e) => {
              setSearchData((prev) => ({
                ...prev,
                tipo: e.id,
                start: 0,
              }));
            }}
            mandatory={false}
          ></Dropdown>
        </div>
        <div className="cell"></div>
        <div className="cell">
          <button className="cell-label" onClick={resetFilters} tabIndex={-1}>
            Limpiar filtros
          </button>
        </div>
        <div className="cell combined-cells-3"></div>
        <div className="cell cell-start-content">Fecha hasta</div>
        <div className="cell">
          <input
            type="date"
            max="9999-12-31"
            tabIndex={3}
            className="input-field input-cell"
            value={searchData.fechaHasta}
            onChange={(e) => {
              const value = e.target.value;
              setSearchData((prev) => ({
                ...prev,
                fechaHasta: value ? moment(value).format("YYYY-MM-DD") : "",
                start: 0,
              }));
            }}
            onKeyUp={(e) => inputOnEnter(e)}
          ></input>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">Canal</div>
        <div className="cell">
          <InputIconSearchPanelMultiSelection
            size={0}
            tabIndex={5}
            type={"type-alphanum-ext"}
            options={crmChannels}
            selectedOptions={selectedChannels}
            onChange={(e) => {
              setSelectedChannels(e);
            }}
          ></InputIconSearchPanelMultiSelection>
        </div>
        <div className="cell combined-cells-2"></div>
        <div className="cell combined-cells-6"></div>
        <div
          className="cell combined-cells-4"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          {selectedChannels.length > 0 && (
            <span style={{ fontWeight: "500", fontSize: 13 }}>
              Canales seleccionados: {selectedChannels.length}
            </span>
          )}
          <div className="tag-content">
            {selectedChannels.map((e, i) => {
              return (
                <Tag
                  text={e}
                  key={i}
                  tagId={i}
                  onClick={(e) => {
                    setSelectedChannels((prev) =>
                      prev.filter((channel) => channel !== e),
                    );
                  }}
                ></Tag>
              );
            })}
          </div>
        </div>
      </div>
      <div
        className="opt-table-title opt-table-title-button"
        style={{ marginTop: 20 }}
      >
        <div>
          Listado de listas ({formatValueUnit(listsListFixed.length)} de{" "}
          <span style={{ color: "#41b3ff" }}>
            {formatValueUnit(totalLists)}
          </span>
          )
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 30,
          }}
        >
          <ButtonIconH
            text="Nueva lista"
            small={true}
            highlight={true}
            onClick={async () => {
              setHandleNewList(true);
            }}
          ></ButtonIconH>
          <ButtonIconH
            text="Eliminar seleccionados"
            small={true}
            disabled={selectedLists.length === 0}
            onClick={async () => {
              createPopupQuestion(
                "¿Desea eliminar las listas seleccionadas?",
                async () => {
                  setSelectedLists([]);
                  setListsListFixed([]);
                  await deleteLists();
                  setSearchData((prev) => ({
                    ...prev,
                    start: 0,
                  }));
                  await getListsList(0);
                  removePopupQuestion();
                },
                () => {
                  removePopupQuestion();
                },
                "Sí",
                "No",
              );
            }}
          ></ButtonIconH>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 5,
          justifyContent: "flex-end",
          paddingBottom: 10,
        }}
      >
        <button className="cell-label" onClick={handleSelectAll} tabIndex={-1}>
          Seleccionar todos
        </button>
        |
        <button className="cell-label" onClick={handleCleanAll}>
          Limpiar selección
        </button>
      </div>
      <DataTable
        columns={columnsWithInputs}
        data={listsListFixed}
        className="custom-datatable datatable-lists"
        noDataComponent="No hay listas disponibles."
        onRowClicked={(row, event) => {
          handleOpenActionPopup("list", row);
        }}
      />
      {listsListFixed.length !== totalLists && (
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 20 }}
        >
          <ButtonIconH
            text="Ver más (+20)"
            small={true}
            onClick={async () => {
              setSearchData((prev) => ({
                ...prev,
                start: prev.start + 20,
              }));
            }}
          ></ButtonIconH>
        </div>
      )}
    </div>
  );
}
